import {Directive, ViewContainerRef} from '@angular/core';

@Directive({standalone: true, selector: '[pubSrcLangSelect]'})
export class SourceLanguageSelectorDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
